<!-- ══ HEADER ══════════════════════════════════════════════════════════ -->
<div class="tracking-modal-header">

  <!-- fila principal: icono + título + botón cierre -->
  <div class="tracking-header-top">

    <!-- icono decorativo -->
    <div class="tracking-header-icon-wrap">
      <i class="ri-route-line"></i>
    </div>

    <!-- títulos -->
    <div class="tracking-header-titles">
      <p class="tracking-header-eyebrow">Regularización DAM</p>
      <h5 class="tracking-header-title">
        Tracking
        <span *ngIf="damTracking?.numero_dam" class="tracking-header-dam-number font-monospace">
          {{ damTracking.numero_dam }}
        </span>
        <span *ngIf="isLoading || (!damTracking?.numero_dam && !hasError)"
              class="tracking-header-dam-placeholder">···</span>
      </h5>
    </div>

    <!-- botón cierre -->
    <button type="button" class="tracking-header-close" (click)="activeModal.dismiss()" aria-label="Cerrar">
      <i class="ri-close-line"></i>
    </button>
  </div>

  <!-- fila de chips: sede + exportador (sólo cuando hay datos) -->
  <div *ngIf="damTracking" class="tracking-header-chips">
    <span class="tracking-chip tracking-chip--sede">
      <i class="ri-map-pin-2-fill"></i>{{ damTracking.sede || '—' }}
    </span>
    <span class="tracking-chip-divider"></span>
    <span class="tracking-chip tracking-chip--cliente text-truncate">
      <i class="ri-building-4-fill"></i>{{ damTracking.cliente || '—' }}
    </span>
  </div>

</div>

<!-- ══ BODY ═══════════════════════════════════════════════════════════ -->
<div class="modal-body p-0 tracking-modal-body">

  <!-- ─ LOADING ────────────────────────────────────────────────────── -->
  <div *ngIf="isLoading" class="tracking-state-center">
    <div class="spinner-border text-secondary" role="status" style="width:2.4rem;height:2.4rem;">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="text-muted mt-3 mb-0 fs-13 letter-spacing-sm">Cargando información del tracking…</p>
  </div>

  <!-- ─ ERROR ──────────────────────────────────────────────────────── -->
  <div *ngIf="!isLoading && hasError" class="tracking-state-center">
    <i class="ri-error-warning-line fs-36 text-danger mb-2"></i>
    <p class="text-danger fw-semibold mb-1">No se pudo cargar la información</p>
    <button class="btn btn-sm btn-outline-secondary mt-1" (click)="recargar()">
      <i class="ri-refresh-line me-1"></i>Reintentar
    </button>
  </div>

  <!-- ─ CONTENT ────────────────────────────────────────────────────── -->
  <div *ngIf="!isLoading && !hasError && damTracking" class="tracking-content">

    <!-- ══ SECCIÓN: IDENTIFICACIÓN ════════════════════════════════════ -->
    <div class="tracking-section-title">
      <i class="ri-id-card-line me-2"></i>Identificación
    </div>

    <div class="tracking-row">
      <div class="tracking-label">DAM N°</div>
      <div class="tracking-value d-flex align-items-center flex-wrap gap-2">
        <strong *ngIf="damTracking.numero_dam" class="font-monospace fs-18 text-primary tracking-dam-number">
          {{ damTracking.numero_dam }}
        </strong>
        <span *ngIf="!damTracking.numero_dam" class="text-muted">—</span>
        <button *ngIf="damTracking.link_dam_regularizada"
           (click)="utilityService.abrirFichero(damTracking.link_dam_regularizada)"
           class="btn btn-success btn-xs tracking-btn-pill">
          <i class="ri-download-2-line me-1"></i>Descargar
        </button>
        <span *ngIf="!damTracking.link_dam_regularizada" class="text-muted fst-italic fs-12">
          <i class="ri-time-line me-1"></i>Sin archivo aún
        </span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Número de Manifiesto</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.manifiesto">{{ damTracking.manifiesto }}</span>
        <span *ngIf="!damTracking.manifiesto" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Término de Embarque</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.termino_embarque">
          <i class="ri-calendar-line text-secondary me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.termino_embarque) }}
        </span>
        <span *ngIf="!damTracking.termino_embarque" class="text-muted">—</span>
      </div>
    </div>

    <!-- ══ SECCIÓN: DOCUMENTACIÓN ══════════════════════════════════════ -->
    <div class="tracking-section-title mt-4">
      <i class="ri-attachment-line me-2"></i>Documentación
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha Recep. Factura</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_recepecion_factura">
          <i class="ri-calendar-check-line text-success me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.fecha_recepecion_factura) }}
        </span>
        <span *ngIf="!damTracking.fecha_recepecion_factura" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha Recepción BL</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_recepecion_bl">
          <i class="ri-calendar-check-line text-success me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.fecha_recepecion_bl) }}
        </span>
        <span *ngIf="!damTracking.fecha_recepecion_bl" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha Último Documento</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_ultimo_documento">
          <i class="ri-time-line text-warning me-1"></i>
          {{ utilityService.obtenerFormatoVistaAMPM(damTracking.fecha_ultimo_documento) }}
        </span>
        <span *ngIf="!damTracking.fecha_ultimo_documento" class="text-muted">—</span>
      </div>
    </div>

    <!-- ══ SECCIÓN: OBSERVACIONES ══════════════════════════════════════ -->
    <div class="tracking-section-title mt-4">
      <i class="ri-alert-line me-2"></i>Observaciones
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Observación</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.observacion">
          <i class="ri-error-warning-line text-warning me-1"></i>
          {{ damTracking.observacion }}
        </span>
        <span *ngIf="!damTracking.observacion">
          <span class="badge bg-danger rounded-pill px-3 fs-11 tracking-badge-status">SIN OBSERVACIÓN</span>
        </span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha de Observación</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_observacion">
          <i class="ri-calendar-line text-secondary me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.fecha_observacion) }}
        </span>
        <span *ngIf="!damTracking.fecha_observacion" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha Solución Obs.</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_solucion_observacion">
          <i class="ri-checkbox-circle-line text-success me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.fecha_solucion_observacion) }}
        </span>
        <span *ngIf="!damTracking.fecha_solucion_observacion" class="text-muted">—</span>
      </div>
    </div>

    <!-- ══ SECCIÓN: REGULARIZACIÓN ══════════════════════════════════════ -->
    <div class="tracking-section-title mt-4">
      <i class="ri-check-double-line me-2"></i>Regularización
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Forma de Regularización</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.forma_regularizacion">
          <span class="badge rounded-pill px-3 fw-semibold fs-11"
                [ngClass]="{
                  'bg-warning text-dark': damTracking.forma_regularizacion === 'EN PROCESO',
                  'bg-success': damTracking.forma_regularizacion !== 'EN PROCESO'
                }">
            {{ damTracking.forma_regularizacion }}
          </span>
        </span>
        <span *ngIf="!damTracking.forma_regularizacion" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha de Regularización</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_regularizacion">
          <i class="ri-calendar-check-line text-success me-1"></i>
          {{ utilityService.obtenerFormatoVistaDDMMYYY(damTracking.fecha_regularizacion) }}
        </span>
        <span *ngIf="!damTracking.fecha_regularizacion" class="text-muted">—</span>
      </div>
    </div>

    <div class="tracking-row">
      <div class="tracking-label">Fecha Envío DAM Reg.</div>
      <div class="tracking-value">
        <span *ngIf="damTracking.fecha_envio">
          <i class="ri-mail-send-line text-primary me-1"></i>
          {{ utilityService.obtenerFormatoVistaAMPM(damTracking.fecha_envio) }}
        </span>
        <span *ngIf="!damTracking.fecha_envio" class="text-muted">—</span>
      </div>
    </div>

    <!-- ══ SECCIÓN: INDICADORES KPI ══════════════════════════════════════ -->
    <div class="tracking-section-title mt-4">
      <i class="ri-bar-chart-2-line me-2"></i>Indicadores KPI
    </div>

    <div class="row g-3 mt-1">
      <!-- KPI Global -->
      <div class="col-6">
        <div class="kpi-card" [ngClass]="kpiBgClass(damTracking.kpi)">
          <div class="kpi-card__value" [ngClass]="kpiClass(damTracking.kpi)">
            <span *ngIf="damTracking.kpi != null" class="font-monospace">{{ damTracking.kpi }}</span>
            <span *ngIf="damTracking.kpi == null" class="text-muted">—</span>
          </div>
          <div *ngIf="damTracking.kpi != null" class="kpi-card__unit">días</div>
          <div class="kpi-card__footer">
            <i class="ri-dashboard-line me-1"></i>KPI Global
          </div>
        </div>
      </div>

      <!-- KPI Operador -->
      <div class="col-6">
        <div class="kpi-card" [ngClass]="kpiBgClass(damTracking.kpi_operador)">
          <div class="kpi-card__value" [ngClass]="kpiClass(damTracking.kpi_operador)">
            <span *ngIf="damTracking.kpi_operador != null" class="font-monospace">{{ damTracking.kpi_operador }}</span>
            <span *ngIf="damTracking.kpi_operador == null" class="text-muted">—</span>
          </div>
          <div *ngIf="damTracking.kpi_operador != null" class="kpi-card__unit">días</div>
          <div class="kpi-card__footer">
            <i class="ri-user-line me-1"></i>KPI Operador
            <i class="ri-information-line ms-1 text-info"
               ngbTooltip="Días transcurridos desde el zarpe hasta la recepción de factura"></i>
          </div>
        </div>
      </div>
    </div>

  </div><!-- /tracking-content -->

</div><!-- /modal-body -->

<!-- ══ FOOTER ══════════════════════════════════════════════════════════ -->
<div class="modal-footer bg-light border-top">
  <button type="button" class="btn btn-warning btn-sm px-4" (click)="activeModal.close()">
    <i class="ri-arrow-left-line me-1"></i>Cerrar
  </button>
</div>
